import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';
import { Form, Button, ButtonGroup, Row, Col } from 'reactstrap';
import { array, number } from 'prop-types';
import { getBaseApiUrl, API_VERSION } from '../../config';

class PromoGroupFilter extends PureComponent {
  static propTypes = {
    names: array.isRequired,
    sizes: array.isRequired,
    types: array.isRequired,
    offerId: number.isRequired,
  };

  static defaultProps = {
    names: [],
    sizes: [],
    types: [],
  };

  state = {
    type: 'all',
    size: null,
    collection: null,
  };

  isActive = type => this.state.type === type;

  handleSizeChange = selected => {
    const value = selected === null ? null : selected.value;

    this.setState(
      () => ({ size: value }),
      () => {
        this.props.onChange(this.state);
      },
    );
  };

  handleCollectionChange = selected => {
    const value = selected === null ? null : parseInt(selected.value, 10);

    this.setState(
      () => ({ collection: value }),
      () => {
        this.props.onChange(this.state);
      },
    );
  };

  handleTypeChange = type => {
    this.setState(
      () => ({ type }),
      () => {
        this.props.onChange(this.state);
      },
    );
  };

  getDownloadLink = (offerId, collectionId) => {
    let baseUrl = getBaseApiUrl();
    let link = `${baseUrl}/${API_VERSION}/offers/${offerId}/collection/`;

    if (collectionId) {
      link += `${collectionId}/`;
    }

    return link;
  };

  render() {
    const { names, sizes, types, offerId, shouldHideSelectors } = this.props;
    const { size, collection } = this.state;

    return (
      <Form className="offers-promo-filter" autoComplete="off">
        <ButtonGroup className="offers-promo-filter-buttons">
          {types.map(({ type, name }) => (
            <Button
              key={type}
              type="button"
              size="sm"
              color="light"
              active={this.isActive(type)}
              onClick={() => this.handleTypeChange(type)}
              outline
            >
              {name}
            </Button>
          ))}
        </ButtonGroup>
        {
          !shouldHideSelectors &&
            <Row className="align-items-center">
              <Col className="mb-2" lg="5" md="4" sm="6" xs="12">
                <Select
                  name="size"
                  value={size}
                  placeholder={
                    <FormattedMessage id="offer.promo.choose-size" defaultMessage="Choose size..." />
                  }
                  onChange={this.handleSizeChange}
                  options={sizes.map(({ size }) => ({ value: size, label: size }))}
                  className="Select--sm"
                />
              </Col>

              <Col className="mb-2" lg="5" md="5" sm="6" xs="12">
                <Select
                  name="collection"
                  value={collection}
                  placeholder={
                    <FormattedMessage id="offer.promo.choose-collection" defaultMessage="Choose collection..." />
                  }
                  onChange={this.handleCollectionChange}
                  options={names.map(({ name, id }) => ({ value: id, label: name }))}
                  className="Select--sm"
                />
              </Col>

              <Col className="mb-2 text-right" lg="2" md="3" sm="12">
                {collection !== null ? (
                  <a
                    href={this.getDownloadLink(offerId, collection.value)}
                    className="btn btn-primary btn-sm"
                    target="_blank"
                    download
                  >
                    <FormattedMessage id="main.download" defaultMessage="Download" />
                  </a>
                ) : (
                  <a
                    href={this.getDownloadLink(offerId)}
                    className="btn btn-primary btn-sm"
                    target="_blank"
                    download
                  >
                    <FormattedMessage id="offer.promo.download-all" defaultMessage="Download All" />
                  </a>
                )}
              </Col>
            </Row>
        }
      </Form>
    );
  }
}

export default PromoGroupFilter;
